import { Provider } from "mobx-react";
import { PrimeReactProvider } from "primereact/api";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Root from "./Root";
import appStore from "./stores/appStore";
import mainStore from "./stores/mainStore";

const stores = {
    appStore,
    mainStore,
};

const { VITE_NODE_ENV } = import.meta.env;

const Routing = () => {
    console.log("VITE_NODE_ENV => ", VITE_NODE_ENV);

    return (
        <PrimeReactProvider>
            <Provider {...stores}>
                <BrowserRouter basename={import.meta.env.BASE_URL}>
                    <Routes>
                        <Route path={"/:firstParam/:secondParam/:thirdParam/:fourthParam"} element={<Root />} />
                        <Route path={"/:firstParam/:secondParam/:thirdParam"} element={<Root />} />
                        <Route path={"/:firstParam/:secondParam"} element={<Root />} />
                        <Route path={"/:firstParam"} element={<Root />} />
                        <Route path={"/"} element={<Root />} />
                    </Routes>
                </BrowserRouter>
            </Provider>
        </PrimeReactProvider>
    );
};

export default Routing;
